function generateItemListSchema() {
  // Check if the script is already present
  const container = document.querySelector("#searchspring-content");
  if (!container) return;

  // Check if the collection have no products
  const noProduct = container.querySelector(".ss-no-results-container");
  if(noProduct) return

  const productCards = container.querySelectorAll(".product-card");
  if (!productCards.length) return;

  let itemList = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: Array.from(productCards).map((card, index) => {
      const titleEl = card.querySelector(".product-card__title > a");
      const imageEl = card.querySelector(".responsive-image__image");
      const priceEl = card.querySelector(".product-card__price");

      let price = "";
      let priceCurrency = "";

      if (priceEl) {
        const priceText = priceEl.textContent.trim();
        const priceMatch = priceText.match(/([\d.,]+)/);
        const currencyMatch = priceText.match(/[A-Z]{3}/);

        price = priceMatch ? priceMatch[1] : "";
        priceCurrency = currencyMatch ? currencyMatch[0] : "";
      }

      const ratingElement = card.querySelector(".sr-only.ng-binding.ng-scope");
      const ratingText = ratingElement ? ratingElement.textContent.trim() : "";
      const ratingMatch = ratingText.match(/[\d.]+/);
      const rating = ratingMatch ? parseFloat(ratingMatch[0]) : 4.5;

      const reviewsElement = card.querySelector(".text-m.ng-binding");
      const reviewsMatch = reviewsElement ? reviewsElement.textContent.match(/\d+/) : null;
      const reviews = reviewsMatch ? parseInt(reviewsMatch[0]) : 1;

      if (!titleEl || !titleEl.href || !imageEl.src || !price || !priceCurrency || !rating || rating < 1 || rating > 5) {
        return null;
      }

      return {
        "@type": "ListItem",
        position: index,
        item: {
          "@type": "Product",
          name: titleEl ? titleEl.textContent.trim() : "",
          url: titleEl ? titleEl.href : "",
          image: imageEl ? imageEl.src : "",
          offers: {
            "@type": "Offer",
            url: titleEl ? titleEl.href : "",
            price: price,
            priceCurrency: priceCurrency,
            priceValidUntil: "12-12-2030",
            availability: "https://schema.org/InStock",
          },
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: rating,
            bestRating: ratingMatch ? 5 : 4.5,
            ratingCount: reviews,
          },
        },
      };
    }),
  };

  itemList = {
    ...itemList,
    itemListElement: itemList.itemListElement.filter((item) => item),
  };
  if (!itemList.itemListElement.length) return;

  const oldScript = document.getElementById("schema-itemlist");
  if (oldScript) oldScript.remove();

  const script = document.createElement("script");
  script.id = "schema-itemlist";
  script.type = "application/ld+json";
  script.textContent = JSON.stringify(itemList, null, 2);
  document.head.appendChild(script);
}

let attempts = 0;
const interval = setInterval(() => {
  generateItemListSchema();
  attempts++;
  if (document.querySelector("#schema-itemlist") || attempts >= 10) {
    clearInterval(interval);
  }
}, 500);
